import { css, cx } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import type { MessageTemplateTagThemeValues } from './message-template-tag-theme';
import { MessageTemplateTagStyleProps } from './types';

export const baseTagStyle = css`
  display: inline-flex;
  flex: 0 1;
  align-items: center;
  height: 24px;
  padding: ${theme.spacing(0, 1)};
  border: 1px solid ${theme.colors.neutral20};
  border-radius: ${theme.borderRadius.small};
  user-select: none;
  white-space: nowrap;
  margin: 0;
  line-height: 0;
  outline: none;
  cursor: pointer;

  &:hover,
  &:focus {
    cursor: pointer;
    box-shadow: ${theme.shadows.light};
    svg {
      color: ${theme.colors.neutral60};
    }
  }
`;

export const tagErrorStyle = css`
  border-color: ${theme.colors.status.critical};
`;

export const tagReadOnlyStyle = css`
  border-color: ${theme.colors.status.disabled};
  cursor: default;
  color: ${theme.colors.neutral40};
  svg {
    color: ${theme.colors.neutral40};
    cursor: default;
  }
  &:hover,
  &:focus {
    box-shadow: none;
    svg {
      color: ${theme.colors.neutral40};
    }
  }
`;

export const tagPlacedFocusedSelectedStyle = css`
  box-shadow: ${theme.shadows.light};
`;

export const tagFocusStyle = css`
  &:focus {
    box-shadow: ${theme.shadows.light};
  }
`;

export const messageTemplateTagStyle = (_theme: MessageTemplateTagThemeValues, props: MessageTemplateTagStyleProps) => {
  return cx(
    baseTagStyle,
    props.error && tagErrorStyle,
    props.readOnly && tagReadOnlyStyle,
    props.placed && props.focused && props.selected && !props.readOnly && tagPlacedFocusedSelectedStyle,
    !props.placed && !props.readOnly && tagFocusStyle
  );
};
